<template>
    <div class="Scroll">
        <b-list-group class="list-group-accent" v-for="item in news" :key="item.id">
            <b-list-group-item class="h1 list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase" v-if="item.type==='title'">
            {{ item.name }}
            </b-list-group-item>
            
            <!-- <b-list-group-item href="#" :class="item.class" v-else-if="item.ispublic==1 || (userdata && userdata.id)"> -->
                <b-list-group-item :href="item.url && item.url != '' ? item.url : '#'" :class="item.color || item.color == '' ? item.color : list-group-item-accent-primary" target="_blank" v-else >
                <div class="font-weight-bold"><h3>{{ item.name }}</h3>
                </div>
                <div>{{ item.summary }}
                </div>
                <small class="text-muted mr-3">
                    <i class="icon-calendar"></i>&nbsp;&nbsp;{{ item.publishedIn }}
                </small>

                <small class="text-muted mr-3"><i class="icon-user"></i>&nbsp;&nbsp;{{ item.publisherName }}</small>
                <small class="text-muted mr-3"><i class="icon-home"></i>&nbsp;&nbsp;{{ item.location }}</small>
                <small class="text-muted" v-show="item.url != ''"><i class="icon-link"></i>&nbsp;&nbsp;Link</small>
                <div>

                </div>
                
            </b-list-group-item>
        </b-list-group>

        <div slot="footer">
        
            <b-row class="text-center">
                <b-col class="mb-sm-2 mb-0">
                    <div class="text-muted">Total de notícias</div>
                    <strong>{{ news.length }} notícias</strong>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from "axios";

let now = new Date();

export default {
    name: 'componentNews',
    data: function() {
        return {
            news: [
                /*

                {
                    "id": 2,
                    "type": "event",
                    "color": "success",
                    "title": "Copa do Mundo - Em breve o Brasil competirá pelo Hexa",
                    "summary": "Veja como será a programação das lojas BMW Agulhas Negras.",
                    "date": "2022-04-08",
                    "time": "1-3pm",
                    "icon": "icon-location-pin",
                    "location": "A6i",
                    "class": "list-group-item-accent-danger",
                    "invited": [{
                        "id": 342,
                        "avatar": "img/avatars/3.jpg",
                        "name": "Adriana",
                        "email": "adriana@a6i.com.br",
                        "username": "adriana"
                    }]
                },

                {
                    "type": "event",
                    "color": "success",
                    "title": "Confraternização Agulhas Negras 2022",
                    "date": "2022-04-08",
                    "summary": "No dia 11 de Dezembro no Sìtio Romão em Atibaia, acontecerá nossa festa de confraternização. Passaremos o dia celebrando as conquista de 2022, juntamento com nossos colegas de trabalho e familiares.",
                    "time": "2-5pm",
                    "icon": "icon-location-pin",
                    "location": "Skype",
                    "class": "list-group-item-accent-warning",
                    "invited": [{
                            "avatar": "img/avatars/2.jpg",
                            "name": "Adriana",
                            "email": "adriana@a6i.com.br",
                            "username": "adriana"
                        },
                        {
                            "avatar": "img/avatars/3.jpg",
                            "name": "Adriana",
                            "email": "adriana@a6i.com.br",
                            "username": "adriana"
                        }
                    ]
                },
                {
                    "type": "event",
                    "color": "success",
                    "title": "Convênio Farmácia Descontinuado",
                    "summary": "Vamos buscar um novo parceiro para dar continuidade a esse benefício, mas por hora informamos que o convênio atual estará ativo até 08 de Dezembro de 2022.",
                    "date": "2022-04-08",
                    "time": "2-5pm",
                    "icon": "icon-location-pin",
                    "location": "Skype",
                    "class": "list-group-item-accent-primary",
                    "invited": [{
                            "avatar": "img/avatars/2.jpg",
                            "name": "Adriana",
                            "email": "adriana@a6i.com.br",
                            "username": "adriana"
                        },

                    ]
                },
                {
                    "type": "event",
                    "color": "success",
                    "title": "Estamos Contratando Analista de Infraestrutura",
                    "summary": "Para trabalhar em nossa unidade de São Bernardo do Campo. Experiência com: Big Data, Cloud Computing, Outsourcing, Redes de Telecomunicações, Segurança da Informação, Virtualização de Aplicações/Desktops/Servidores e ter de 2 a 3 anos de experiência.",
                    "date": "2022-04-08",
                    "time": "2-5pm",
                    "icon": "icon-location-pin",
                    "location": "Skype",
                    "class": "list-group-item-accent-success",
                    "invited": [{
                            "avatar": "img/avatars/5.jpg",
                            "name": "Adriana",
                            "email": "adriana@a6i.com.br",
                            "username": "adriana"
                        },
                        {
                            "avatar": "img/avatars/1.jpg",
                            "name": "Adriana",
                            "email": "adriana@a6i.com.br",
                            "username": "adriana"
                        }
                    ]
                }
                */

            ]
        }
    },
    methods: {
        async refreshData() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            
            var currentUserURL = currentUserURL = "&uid=" + this.$store.state.currentUser.id + "&sid=" + this.$store.state.currentUser.sid;
            
            if(currentUserURL.indexOf("undefined") >= 0)
                currentUserURL = ''

            await axios.get(
                this.$store.state.ws_url + "/portal/news?companyId=" + this.$store.state.config.companyId + currentUserURL
            ).then(function(resp) {
                s.news = resp.data.obj
            }).catch(function(error) {
                s.news = []
            })
        },

    },
    mounted: function(){
        this.refreshData();
    },
    computed: {
        userdata() {
          return this.$store.state.currentUser;
        }
    }
}
</script>

<style scoped>
   #wrapper {
        display:flex;    
        width:100%;
        align-content: streach;
        justify-content: space-between;
    }    

    #wrapper div {
        /* height:100px; */
    }

    .staticMain {
        flex: 0 0 800px;
    }
    .staticLeft {
        flex: 0 0 330px;
    }

    .staticDiv {
        flex: 0 0 10px;
    }

    .growMax {
        flex-grow: 1;
    }
    .Scroll {
        max-height: 600px;
        overflow-y: auto;
        overflow-x: hidden;
        overflow-wrap: break-word;
        word-break: break-word;
        /* Cor do scroll: ver regra global em src/assets/scss/_custom.scss */
    }
</style>
